/* eslint-disable */
import React from 'react';
import {
 ColDef,
 IDateFilterParams,
 ITextFilterParams,
} from '@ag-grid-community/core';
import CellRenderClipboard from '../../Shared/DataGrid/CellRenderClipboard';

const MutualPaymentColumns = () => {
 const columns: ColDef[] = [];

 let column: ColDef = {
  field: 'recordNumber',
  headerName: '№',
  minWidth: 100,
  maxWidth: 100,
  filter: false,
  sortable: false,
  pinned: 'left',
  suppressFiltersToolPanel: true,
  suppressMenu: true,
  resizable: false,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center',
  }),
 };
 columns.push(column);

 column = {
  field: 'documentNumber',
  headerName: 'Номер документа',
  minWidth: 400,
  filter: 'agTextColumnFilter',
  filterParams: {
   buttons: ['apply', 'reset'],
   closeOnApply: true,
  } as ITextFilterParams,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'left',
  }),
  lockVisible: false,
  cellRenderer: CellRenderClipboard,
 };

 column = {
  field: 'document',
  headerName: 'Документ',
  minWidth: 400,
  filter: 'agTextColumnFilter',
  filterParams: {
   buttons: ['apply', 'reset'],
   closeOnApply: true,
  } as ITextFilterParams,
  cellStyle: () => ({
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'left',
  }),
  lockVisible: false,
  cellRenderer: CellRenderClipboard,
 };
 columns.push(column);

 column = {
  field: 'startDebt',
  headerName: 'Долг на начало периода, ₽',
  minWidth: 200,
  cellClass: 'ag-left-aligned-cell',
  cellRenderer: CellRenderClipboard,
  valueFormatter: function (params) {
   return params?.data?.startDebt
    ? params.data.startDebt.toLocaleString('ru-RU')
    : null;
  },
  filter: 'agNumberColumnFilter',
 };
 columns.push(column);

 column = {
  field: 'accrued',
  headerName: 'Начислено, ₽',
  minWidth: 200,
  cellClass: 'ag-left-aligned-cell',
  cellRenderer: CellRenderClipboard,
  valueFormatter: function (params) {
   return params?.data?.accrued
    ? params.data.accrued.toLocaleString('ru-RU')
    : null;
  },
  filter: 'agNumberColumnFilter',
 };
 columns.push(column);

 column = {
  field: 'paid',
  headerName: 'Оплачено, ₽',
  minWidth: 200,
  cellClass: 'ag-left-aligned-cell',
  cellRenderer: CellRenderClipboard,
  valueFormatter: function (params) {
   return params?.data?.paid ? params.data.paid.toLocaleString('ru-RU') : null;
  },
  filter: 'agNumberColumnFilter',
 };
 columns.push(column);

 column = {
  field: 'endDebt',
  headerName: 'Долг на конец периода, ₽',
  minWidth: 200,
  cellClass: 'ag-left-aligned-cell',
  cellRenderer: CellRenderClipboard,
  valueFormatter: function (params) {
   return params?.data?.endDebt
    ? params.data.endDebt.toLocaleString('ru-RU')
    : null;
  },
  filter: 'agNumberColumnFilter',
 };
 columns.push(column);

 return { columns };
};

export { MutualPaymentColumns };
